import * as z from "zod";

const washingInstructionSchema = z.object({
  icon: z.string().optional(),
  description: z.string().optional(),
});

export const createArticleSchema = z
  .object({
    article_title: z.string().optional(),
    article_id: z
      .string({ message: "Required" })
      .max(100, { message: "Article id must not exceed 100 characters" })
      .min(1, { message: "Required" }),
    brand: z.string().optional(),
    description: z.string().optional(),
    sku: z
      .string({ message: "Required" })
      .max(100, { message: "Article no. must not exceed 100 characters" })
      .optional()
      .or(z.literal("")),
    workspace_id: z.number({
      required_error: "Required",
      invalid_type_error: "Required",
    }),

    compositions: z
      .array(
        z.object(
          {
            label: z.string({ message: "Required" }),
            value: z.number({
              message: "Required",
              invalid_type_error: "Required",
            }),
          },
          {
            required_error: "Required",
            invalid_type_error: "Required",
          },
        ),
      )
      .nonempty({ message: "Required" }),
    gender_id: z.object(
      {
        label: z.string({ message: "Required" }),
        value: z.number({ message: "Required" }),
      },
      { required_error: "Required", invalid_type_error: "Required" },
    ),
    template_id: z.object(
      {
        label: z.string({ message: "Required" }),
        value: z.number({ message: "Required" }),
      },
      { required_error: "Required", invalid_type_error: "Required" },
    ),
    percentage: z
      .array(
        z
          .number({
            required_error: "Required",
            invalid_type_error: "Required",
          })
          .min(0.01, { message: "Percentage must be greater than 0" }),
      )
      .nonempty({ message: "At least one percentage is required" }),

    article_type: z.object(
      {
        label: z.string({ message: "Required" }),
        value: z.number({ message: "Required" }),
      },
      {
        required_error: "Required",
        invalid_type_error: "Required",
      },
    ),
    washing_instructions: z.array(washingInstructionSchema).optional(),
  })
  .refine(
    (data) => {
      // do the sum of percentage should be 100
      const sum = data.percentage.reduce((a, b) => a + b, 0);
      return Math.round(sum * 100) / 100 === 100;
    },
    {
      path: ["sum"],
      message: "The total percentage must equal 100%.",
    },
  );
